import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'student-view-layout',
  templateUrl: './student-view-layout.component.html',
})
export class StudentViewLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
